export enum PlayerDataSelectionEnum {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
